import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchRevParReport } from '@/renderer/services/accommodationService';

export function useRevParReport(
  propertyId: string | null | undefined,
  dateFrom: string,
  dateTo: string,
) {
  return useQuery({
    queryKey: queryKeys.accommodation.revPar(
      propertyId ?? '',
      dateFrom,
      dateTo,
    ),
    queryFn: () => fetchRevParReport(propertyId!, dateFrom, dateTo),
    enabled: !!propertyId && !!dateFrom && !!dateTo,
    staleTime: 1000 * 60 * 5,
  });
}
